import React from 'react';
import { VehiclesProvider } from '../contexts/VehiclesContext';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stock } from '../components/Stock';
import { Electrico } from '../components/Electrico';
import { AlquilerApps } from '../components/AlquilerApps';
import { Consignacion } from '../components/Consignacion';
import { InversionesBanner } from '../components/InversionesBanner';
import { ServicesOverview } from '../components/ServicesOverview';
import { WhyUs } from '../components/WhyUs';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { AdminPanel } from '../components/AdminPanel';
export function Home() {
  return <VehiclesProvider data-id="element-549" data-mp="3kv0jusbstsmo">
      <div className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-550" data-mp="3owvljxxn680z">
        <Navbar data-id="element-551" data-mp="30x1i8cwkkkpg" />
        <main data-id="element-552" data-mp="30vgogpi2x5sn">
          <Hero data-id="element-553" data-mp="30w04u1s2zm4k" />
          <Stock data-id="element-554" data-mp="30ufb2edlc77r" />
          <Electrico data-id="element-555" data-mp="2vxyagkp7g0ds" />
          <AlquilerApps data-id="element-556" data-mp="2vxf5e4knl6h6" />
          <Consignacion data-id="element-557" data-mp="2vy836g1mwln6" />
          <InversionesBanner data-id="element-558" data-mp="2vvlz4qdyco9p" />
          <ServicesOverview data-id="element-559" data-mp="2qy2i5ipvdxe2" />
          <WhyUs data-id="element-560" data-mp="2qxal03gmjrlo" />
          <Testimonials data-id="element-561" data-mp="2qwshclrmub3q" />
          <Contact data-id="element-562" data-mp="2r0g8xfdionft" />
        </main>
        <Footer data-id="element-563" data-mp="2mxrzb5gzbchs" />
        <FloatingWhatsApp data-id="element-564" data-mp="2mw8lrmmpjfjp" />
        <AdminPanel data-id="element-565" data-mp="2mz35td1t6ycl" />
      </div>
    </VehiclesProvider>;
}